<template>
  <div class="home-container">
    <div class="home-content" v-if="answerFlag">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          @click="back"
          style="width: 90px"
          >返回</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="答卷时间" align="center">
        </el-table-column>
        <el-table-column label="问卷详情" align="center">
          <template slot-scope="scope">
            <a href="#" @click="bindDetail(scope.row)">问卷详情</a>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="home-content" v-else>
        <questionnaireAnswerList :objId="objId" :questionnaireId="questionnaireId" @answerBack="answerBack"></questionnaireAnswerList>
    </div>
  </div>
</template>

<script>
import reg from "../../utils/reg";
import questionnaireAnswerList from "./questionnaireAnswerList.vue";
export default {
  components: {
    questionnaireAnswerList,
  },
  props: {
    questionnaireId: Number,
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      searchForm: {
        userName: "",
        startTIme: "",
        endTime: "",
        time: "",
      },
      objId: {},
      answerFlag: true,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    answerBack(){
        this.answerFlag = true
    },
    // 获取问卷详情
    bindDetail(row) {
      this.objId = row;
      this.answerFlag = false;
    },
    back() {
      this.$emit("recordBack", true);
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        questionnaireId: this.questionnaireId,
      };
      this.$Apis.questionnaireRecord(data).then((res) => {
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>